import { apiUrl } from '@/api/client';

/** URL del logo de la empresa. Si no hay uno cargado, usa el ícono de la app. */
export function resolveBrandLogoSrc(logoUrl: string | null | undefined): string {
  const raw = logoUrl?.trim();
  if (!raw) return '/logo.png';

  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    try {
      const u = new URL(raw);
      if (u.pathname.startsWith('/api/public/org/') && /\/logo$/.test(u.pathname)) {
        return apiUrl(`${u.pathname}${u.search}`);
      }
    } catch {
      /* se deja la URL absoluta */
    }
    return raw;
  }
  return apiUrl(raw.startsWith('/') ? raw : `/${raw}`);
}
